<template>
  <ion-header class="ion-no-border">
    <ion-toolbar class="padding-xs header-toolbar-small" color="primary">
      <div>
        <ion-buttons @click="$emit('back-button')" slot="start">
          <ion-button
            color="primary"
            shape="round"
            size="small"
            fill="clear"
            class="ion-no-padding"
          >
            <ion-icon color="white" size="large" :icon="arrowBack"></ion-icon>
          </ion-button>

          <section v-if="!hideUser" class="user-avatar-wrapper">
            <ion-avatar class="user-avatar-wrapper__avatar">
              <img v-if="user?.photo" :alt="user?.fullName ?? ''" :src="user?.photo" />
              <ion-label v-else>{{
                user?.fullName ? user?.fullName.substring(0, 2) : user?.email.substring(0, 2)
              }}</ion-label>
            </ion-avatar>

            <div v-if="isSomeoneInChat" class="online"></div>
          </section>

          <div v-if="!hideUser">
            <ion-label class="text-weight-bold ml-xs">{{ user?.fullName }}</ion-label>
            <p v-if="isSomeoneInChat" class="ml-xs">{{ t('support.online') }}</p>
          </div>
        </ion-buttons>
      </div>
    </ion-toolbar>
  </ion-header>
</template>

<script setup lang="ts">
  import {
    IonHeader,
    IonToolbar,
    IonButtons,
    IonButton,
    IonIcon,
    IonLabel,
    IonAvatar,
  } from '@ionic/vue';
  import { arrowBack } from 'ionicons/icons';
  import { User } from '@/interfaces/auth/auth-store.interface';
import { storeToRefs } from 'pinia';
import { useChatStore } from '@/stores/chat-store';
import { useI18n } from 'vue-i18n';

  withDefaults(
    defineProps<{
      title: string;
      user?: User;
      hideUser?: boolean
    }>(),
    {},
  );

  const { t } = useI18n();
  const { isSomeoneInChat } = storeToRefs(useChatStore());
</script>

<style lang="scss" scoped>
  .user-avatar-wrapper {
    position: relative;

    &__avatar {
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: var(--ion-color-primary-light);
      color: white;
      font-size: 1rem;
      font-weight: bold;
      width: 45px;
      height: 45px;
    }
  }

 /*  .header-navbar {
    position: absolute;
    z-index: -1;
  } */

  .header-toolbar {
    height: 130px;
    padding-top: 10px;
  }

  .header-toolbar-small {
    height: 70px;
    padding-top: 10px;
  }

  .header-logo {
    position: relative;
    margin-top: 10px;
    width: 100%;
    display: flex;

    ion-img {
      width: 100px;
    }
  }

  ion-select {
    --placeholder-color: white;
    --border-color: white;
    --ripple-color: white;
  }

  .avatar {
    width: 36px;
    height: 36px;
  }

  .online{
    background-color: greenyellow;
    width: 14px;
    height: 14px;
    position: absolute;
    right: -5px;
    border-radius: 100%;
    top: 30px;
  }
</style>
